var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',{class:_vm.$style.layout},[_c('div',{class:_vm.$style.container},[_c('div',{class:_vm.$style.sideMenu},[_c('SideMenu')],1),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }